import { distance as turfDistance, point } from "@turf/turf";
import { useEffect, useMemo, useState } from "react";

import { getPreciseLocation, parseMarketCoords } from "@/utils/geo/geo";

interface UseMarketDistanceArgs {
    marketGeo: string | null;
}

const formatDistance = (meters: number): string => {
    const m = Math.round(meters);

    if (m < 1000) {
        return `${m} м`;
    }

    const km = Math.floor(m / 1000);
    const restMeters = m % 1000;

    return restMeters === 0 ? `${km} км` : `${km} км ${restMeters} м`;
};

export const useMarketDistance = ({ marketGeo }: UseMarketDistanceArgs) => {
    const marketCoords = useMemo(
        () => parseMarketCoords(marketGeo),
        [marketGeo],
    );

    const [loading, setLoading] = useState(false);
    const [distance, setDistance] = useState("Відстань до ТТ не визначена");

    useEffect(() => {
        const getCoords = async () => {
            if (!marketCoords) {
                return;
            }

            try {
                setLoading(true);

                const coords = await getPreciseLocation();

                if (marketCoords) {
                    const myPoint = point([coords.lng, coords.lat]);
                    const marketPoint = point(marketCoords);

                    const dist = turfDistance(myPoint, marketPoint, {
                        units: "meters",
                    });

                    const distRounded = Math.round(dist);

                    setDistance(
                        `Відстань до ТТ ${formatDistance(distRounded)}`,
                    );
                }
            } catch (error) {
                return;
            } finally {
                setLoading(false);
            }
        };

        getCoords();
    }, [marketCoords]);

    return { distance, loading };
};
